import { render, staticRenderFns } from "./SignatureV1Properties.vue?vue&type=template&id=b696cdd0&"
import script from "./SignatureV1Properties.vue?vue&type=script&lang=js&"
export * from "./SignatureV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports